function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.888 26.54A11.965 11.965 0 0 1 4 22c0-6.627 5.373-12 12-12s12 5.373 12 12c0 .282-.01.563-.029.84 1.924.122 2.853.16 4.029.16v2c-1.412 0-2.465-.052-5.102-.224-5.038-.329-7.498-.329-10.734.21-1.907.318-3.13.726-5.705 1.78C6.389 28.43 4.153 29 0 29v-2c1.94 0 3.412-.13 4.888-.46zm21.087-3.826c.016-.236.025-.474.025-.714 0-5.523-4.477-10-10-10S6 16.477 6 22c0 1.42.296 2.772.83 3.996a44.245 44.245 0 0 0 2.871-1.081c2.705-1.107 4.042-1.553 6.135-1.901 3.19-.532 5.643-.57 10.139-.3zM16 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zm14.83 10.866a1 1 0 0 1-.366 1.366l-2.598 1.5a1 1 0 0 1-1-1.732l2.598-1.5a1 1 0 0 1 1.366.366zm-29.33 0a1 1 0 0 1 1.366-.366L5.464 12a1 1 0 1 1-1 1.732l-2.598-1.5a1 1 0 0 1-.366-1.366zm28.571-7.159a1 1 0 0 1 0 1.414l-4.95 4.95a1 1 0 0 1-1.414-1.414l4.95-4.95a1 1 0 0 1 1.414 0zm-28.253 0a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1-1.414 1.414l-4.95-4.95a1 1 0 0 1 0-1.414zm20.048.793a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 1 1-1.732-1l1-1.732a1 1 0 0 1 1.366-.366zm-12 0a1 1 0 0 1 1.366.366l1 1.732a1 1 0 0 1-1.732 1l-1-1.732A1 1 0 0 1 9.866 4.5zM30 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM2 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
});

var SvgDaycare = function SvgDaycare(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "2bb4ced7c0459c77dfc64247698e64e9.svg";
export { SvgDaycare as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/daycare.svg
// module id = null
// module chunks = 